const faBoxArrowDown = {
  prefix: 'fal',
  iconName: 'box-arrow-down',
  icon: [
    448,
    512,
    [],
    'e794',
    'M416 160l-384 0 0 256c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256zM208 128l0-80-95.1 0c-10.3 0-20 5-26 13.4L39.3 128 208 128zm200.7 0L361.1 61.4c-6-8.4-15.7-13.4-26-13.4l-95.1 0 0 80 168.7 0zM0 148.5c0-13.3 4.2-26.3 11.9-37.2L60.9 42.8C72.9 26 92.3 16 112.9 16l222.1 0c20.7 0 40.1 10 52.1 26.8l48.9 68.5c7.8 10.9 11.9 23.9 11.9 37.2L448 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 148.5zM212.7 395.3l-72-72c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 345.4 208 224c0-8.8 7.2-16 16-16s16 7.2 16 16l0 121.4 44.7-44.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0z',
  ],
};
export default faBoxArrowDown;
